'use strict';

(function () {
    var btnList = document.querySelector('.catalog-options__button--list')
    var btnGrid = document.querySelector('.catalog-options__button--compact')

    var catalog = document.querySelector('.catalog__cat')
    var quickOrder = document.querySelector('.catalog-quick-order')

    function getCookie(name) {
        var matches = document.cookie.match(new RegExp(
            "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
        ));
        return matches ? decodeURIComponent(matches[1]) : undefined;
    }

    function setCookie (name, value, options) {
        options = options || {}

        var expires = options.expires

        if (typeof expires == 'number' && expires) {
            var d = new Date()
            d.setTime(d.getTime() + expires * 1000)
            expires = options.expires = d
        }
        if (expires && expires.toUTCString) {
            options.expires = expires.toUTCString()
        }

        if (typeof options.path == 'undefined') {
            options.path = '/'
        }

        value = encodeURIComponent(value)

        var updatedCookie = name + '=' + value

        for (var propName in options) {
            updatedCookie += '; ' + propName
            var propValue = options[propName]
            if (propValue !== true) {
                updatedCookie += '=' + propValue
            }
        }

        document.cookie = updatedCookie
    }

    function rememberGrid () {
        window.location.hash = ''
        setCookie('catalog_mode', 'grid', {'expires': 7 * 3600 * 24})
//        window.localStorage.setItem('catalog_mode', 'grid')
    }

    function rememberList () {
        window.location.hash = 'quick'
        setCookie('catalog_mode', 'list', {'expires': 7 * 3600 * 24})
        //window.localStorage.setItem('catalog_mode', 'list')
    }

    if (btnList || btnGrid) {
        if (window.location.hash.indexOf('quick') >= 0 || getCookie('catalog_mode') === 'list') {
            catalog.classList.remove('catalog__wrap')
            catalog.classList.add('catalog__list')
            btnGrid.classList.remove('catalog-options__button--active')
            btnList.classList.add('catalog-options__button--active')
            quickOrder.style.opacity = '1'
            rememberList()
        }

        btnList.addEventListener('click', function () {
            if (!catalog.classList.contains('catalog__list')) {
                catalog.classList.add('catalog__fade')
                rememberList()

                setTimeout(function () {
                    catalog.classList.remove('catalog__fade')
                    catalog.classList.remove('catalog__wrap')
                    catalog.classList.add('catalog__list')
                }, 200)

                btnGrid.classList.remove('catalog-options__button--active')
                btnList.classList.add('catalog-options__button--active')
                quickOrder.style.opacity = '1'
            }
        })

        btnGrid.addEventListener('click', function () {
            if (!catalog.classList.contains('catalog__wrap')) {
                catalog.classList.add('catalog__fade')
                rememberGrid()

                setTimeout(function () {
                    catalog.classList.remove('catalog__fade')
                    catalog.classList.remove('catalog__list')
                    catalog.classList.add('catalog__wrap')
                }, 200)

                btnList.classList.remove('catalog-options__button--active')
                btnGrid.classList.add('catalog-options__button--active')
                quickOrder.style.opacity = '0'

            }
        })
    }

})()
